<template>
  <nav class="navbar">
    <div class="navbar-content">
      <!-- logo -->
      <div class="logo">
        🏆 源码大全
        <span class="description">
          专业为计算机专业类学生定制APP、小程序、网页设计等
        </span>
      </div>

      <!-- 按钮菜单 -->
      <div class="links">
        <button
          :class="{ active: currentView === 'home' }"
          @click="switchView('home')"
        >首页</button>

        <button
          :class="{ active: currentView === 'category' }"
          @click="switchView('category')"
        >源码分类</button>

        <button
          :class="{ active: currentView === 'about' }"
          @click="switchView('about')"
        >关于我们</button>
      </div>


      <!-- 搜索框 -->
      <div class="search">
        <input type="text" v-model="keyword" placeholder="搜索源码  尽量简短  比如商城" />
        <button @click="handleSearch" class="search-btn">
          <!-- 用 SVG 替换 🔍 -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M10 2a8 8 0 105.293 14.293l4.707 4.707 1.414-1.414-4.707-4.707A8 8 0 0010 2zm0 2a6 6 0 110 12 6 6 0 010-12z"/>
          </svg>
        </button>

      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      keyword: '',  // 存储输入的关键字
    }
  },
  props: ['currentView'],
  methods: {
    switchView(view) {
      this.currentView = view
      this.$emit('switch-view', view)
    },
    // 搜索逻辑保持不变
    handleSearch() {
      const k = this.keyword.trim()
      const token = Date.now() // 或者 ++this._searchCounter
      this.$emit('search', { keyword: k, token })
    }
  }
}
</script>

<style scoped>
.navbar {
  background: linear-gradient(90deg, #8f5dea, #5f4ff5);
  color: white;
  padding: 10px 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.navbar-content {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;

  /* 新增 ↓↓↓ */
  justify-content: space-between;
  align-items: center;
  text-align: center;
}


.logo {
  font-weight: bold;
  font-size: 25px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.description {
  font-size: 14px;
  margin-left: 10px;
  margin-top: 15px;
  color: #f0f0f0;
}

.links {
  display: flex;
  list-style: none;
  gap: 20px;
  padding: 0;
}

.links a {
  color: white;
  text-decoration: none;
  font-weight: normal;
  font-size: 18px;
  padding-bottom: 4px; /* 给下划线留空间 */
  transition: color 0.3s, font-weight 0.3s, border-bottom 0.3s;
  border-bottom: 2px solid transparent; /* 默认透明 */
}

.links a.active {
  color: #ffcc00;
  font-weight: bold;
  font-size: 18px;
  border-bottom: 2px solid currentColor; /* 下划线和文字颜色一致 */
}

.search {
  display: flex;
  align-items: center;
  border-radius: 30px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  border: 2px solid #fff;      /* 整个搜索框边框白色 */
  width: 350px;        /* 调整搜索框宽度，可根据需要加大 */
  max-width: 100%;     /* 避免在窄屏时超出屏幕 */
}

.search input {
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  outline: none;
  flex: 1;
  background: transparent;      /* 背景透明，让白色边框可见 */
  color: #eeecec;                  /* 输入文字白色，更明显 */
}

.search input::placeholder {
  color: rgba(255, 255, 255, 0.6); /* 浅白色，透明度0.6 */
  font-size: 16px;                 /* 可选：和输入文字一致 */
}

.search-btn {
  border: none;
  background: linear-gradient(135deg, #f6d365, #fda085);
  color: #333;
  padding: 10px 16px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s;
  border-radius: 0 30px 30px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-btn:hover {
  background: linear-gradient(135deg, #ff9c6b, #ff9c6b);
}

.search-btn svg {
  display: block;
}

.links button {
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  font-weight: normal;
  padding: 4px 10px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: color 0.3s, font-weight 0.3s, border-bottom 0.3s;
}

.links button.active {
  color: #ffcc00;
  font-weight: bold;
  border-bottom: 2px solid currentColor;
}

/* 响应式 */
@media (max-width: 960px) {
  .navbar-content {
    justify-content: center; /* 内容居中 */
  }

  .logo {
    width: 100%;
    justify-content: center;
    margin-bottom: 10px;
    text-align: center;
  }

  .links {
    width: 100%;
    justify-content: center;
    margin-bottom: 10px;
  }

  .search {
    width: 100%;
    max-width: 400px;
    margin-bottom: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue